import { pushReferral } from './utils';

pushReferral(document.referrer);
